module.exports = __webpack_public_path__ + "static/media/campaign-thumbnail-whatsapp.29018191.png";